import React, { Component } from 'react';
import MdDelete from 'react-icons/lib/md/delete';
import { UnofficialRemove } from '../modal/UnofficialRemove';
import { removeUnofficialResults } from './styles';

export class RemoveUnofficialResults extends Component {

  state = {
    open: false,
    success: false
  };

  handleOpen = () => this.setState({open: true});

  handleClose = () => this.setState({open: false});

  onTouchTap = (e) => {
    e.preventDefault();
    this.props.modal.props.isLoggedIn
      ? this.handleOpen() : this.props.modal.handleTouchTap();
  };

  handler = () => this.setState({success: true});

  render() {
    const {
      isMobile,
      modal
    } = this.props;

    return (
      <div>
        <MdDelete
          size="20"
          onClick={this.onTouchTap}
          style={removeUnofficialResults.mdDelete}/>
        <UnofficialRemove
          isMobile={isMobile}
          open={this.state.open}
          handleOpen={this.handleOpen}
          handleClose={this.handleClose}
          handler = {this.handler}
          eventCourseId={modal.props.eventCourseId}
          raceName={modal.props.raceName}
          raceDate={modal.props.raceDate}
          athleteId={modal.props.athleteId}
          modal={modal}
        />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./components/control/RemoveUnofficialResults.js
 **/